import lazyLoading from './lazyLoading'

export default {
  name: 'ArticleWriter',
  hidden: true,
  component: lazyLoading('articleWriter', true),
  path: '/article_writer',
  meta: {
    auth: false,
    link: 'article_writer/:writerId'
  },
  children: [
    {
      name: 'WriterArticleEdit',
      path: '/article_writer/:writerId/:articleId',
      component: lazyLoading('articleWriter/EditArticle'),
      meta: {},
      props: true
    },
    {
      name: 'WriterArticlesList',
      path: '/article_writer/:writerId',
      component: lazyLoading('articleWriter/articlesList', true),
      meta: {},
      props: true
    }
  ]
}
